import { combineReducers, type Reducer, type AnyAction } from 'redux';

import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { entities } from './entities';
import { request as requests } from './request';
import { user } from './user';
import { settings } from './settings';
import { ui } from './ui';
import { filters } from './filters';
import { page } from './page';
import { common } from './common';
import { auth } from './auth';
import { blockNavigation } from './blockNavigation';

export const buildRootReducer = (locationReducer: Reducer<any, AnyAction>) =>
    combineReducers({
        common,
        location: locationReducer,
        page,
        entities,
        requests,
        user: persistReducer(
            {
                key: 'user',
                storage
            },
            user
        ),
        auth: persistReducer(
            {
                key: 'auth',
                storage
            },
            auth
        ),
        settings,
        ui,
        filters,
        blockNavigation
    });
